import styled from 'styled-components';
import { DropdownMenuList } from '../SimpleDropdownMenu/styles';
import { Format } from '../../utils/styles-constants';

const DropdownContainer = styled('div')`
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	z-index: 12;
`;

const DropDownList = styled(DropdownMenuList)`
	min-width: 340px;

	@media ${Format.SmartphonePortrait} {
		min-width: 280px;
	}
`;

export {
	DropdownContainer,
	DropDownList,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ContextualMenu/styles.ts